import styled from "styled-components/macro";

export const DetailPage = styled.div`
  margin: 0 15px;
`;
